import { Button, Divider } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { PageBreadcrumbDivider } from 'framework/components/breadcrumbs/PageBreadcrumbDivider';
import { PageBreadcrumbTitle } from 'framework/components/breadcrumbs/PageBreadcrumbTitle';
import { PageReloadButtonX } from 'framework/components/layout/PageReloadButtonX';
import { PageXHeaderActions } from 'framework/components/layout/PageXHeaderActions';
import { QueryResultPaginationX } from 'framework/components/pagination/QueryResultPaginationX';
import { SearchbarX } from 'framework/components/search/SearchbarX';
import { useQueryContext } from 'framework/hooks/useQueryContext';
import { onResetToPage1 } from 'framework/types/onResetToPage1';
import { CompanyExportProp, CompanyExportProps, ICompaniesFilterParams, companiesQuery_export } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useMemo, useState } from 'react';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';
import { TextLinkExportButtonMenuAndDialog } from 'shared/export/TextLinkExportButtonMenuAndDialog';
import { RestrictedPageX } from 'shared/layout/RestrictedPageX';
import { CompaniesListFilterCard } from './CompaniesListFilterCard';
import { CompaniesQueryContext } from './CompaniesQueryContext';
import { CompanyDetailsCard } from './CompanyDetailsCard';
import { CompanyListItemCardX } from './CompanyListItemCardX';
import { createCompaniesExportRecord } from './createCompaniesExportRecord';
import { RegisterCompanyForm } from './forms/RegisterCompanyForm';

export const CompaniesPage = () => {
	const { reload, queryResult, params, setParams } = useQueryContext(CompaniesQueryContext);
	const strings = useLocalization();
	const { open, confirm, cancel } = useDialogsContext(reload);
	const exportRecord = useMemo(() => createCompaniesExportRecord(strings), [strings]);
	const [expandedId, setExpandedId] = useState<string>();
	const expandedCompany = useMemo(() => queryResult?.values.find(t => t.id === expandedId), [queryResult, expandedId]);

	const onCreate = () => {
		open(
			<RegisterCompanyForm
				open
				confirm={confirm}
				cancel={cancel}
			/>
		);
	};

	if (queryResult === undefined) {
		return <></>;
	}

	return (
		<RestrictedPageX
			pageClaim='VatCustomers'
			maxWidth={1280}
			stickyHeader={
				<div
					className='df-col gap-8 fg1'
					style={{ paddingBottom: 16 }}>
					<div className='df-row-ac'>
						<PageBreadcrumbTitle title={strings.contacts} />
						<PageBreadcrumbDivider />
						<PageBreadcrumbTitle title={strings.vatCustomers} />
						<div className='fg1'></div>
						<PageXHeaderActions>
							<PageReloadButtonX reload={reload} />
						</PageXHeaderActions>
					</div>
					<SearchbarX
						placeholder={strings.searchVerb}
						value={params.searchString}
						onSearch={val => setParams(onResetToPage1({ ...params, searchString: val }))}
						style={{ width: 500 }}
					/>
				</div>
			}
			stickySidebar={
				<div
					className='df-col gap-16 mh100'
					style={{ padding: 16, paddingRight: 8 }}>
					<Button
						variant='outlined'
						color='primary'
						startIcon={<AddIcon />}
						onClick={onCreate}
						style={{ borderRadius: 12 }}>
						{strings.new}
					</Button>
					<CompaniesListFilterCard
						params={params}
						setParams={setParams}
					/>
					<div className='fg1'></div>
					<Divider />
					<TextLinkExportButtonMenuAndDialog<ICompaniesFilterParams, CompanyExportProp>
						params={params}
						filteredCount={queryResult.filteredCount}
						unfilteredCount={queryResult.unfilteredCount}
						allProps={CompanyExportProps}
						downloadF={companiesQuery_export}
						fileName='BTW_klanten'
						record={exportRecord}
						view='companies'
						style={{ paddingBottom: 0 }}
					/>
				</div>
			}>
			<div
				className='df-row gap-16 h100'
				style={{
					padding: 16,
					paddingLeft: 8,
				}}>
				<div className='df-col gap-8'>
					{queryResult.values.map(t => (
						<CompanyListItemCardX
							key={t.id}
							item={t}
							isSelected={expandedId === t.id}
							toggle={() => setExpandedId(expandedId === t.id ? undefined : t.id)}
						/>
					))}
					<QueryResultPaginationX
						queryResult={queryResult}
						setPageParams={pageParams => setParams({ ...params, pageParams: pageParams })}
						style={{ justifyContent: 'end', paddingTop: 12, marginBottom: -4 }}
					/>
				</div>
				{expandedCompany !== undefined && (
					<>
						<Divider orientation='vertical' />
						<CompanyDetailsCard
							item={expandedCompany}
							className='fg1 h-fc'
							reload={reload}
						/>
					</>
				)}
			</div>
		</RestrictedPageX>
	);
};
